import { useQueryClient } from "react-query";
import { Queries } from "ui/query/queries";
import { authService } from "../services/authService";

export type UseLogoutResponse = {
    logOut: () => Promise<void>;
};

export function useLogout(): UseLogoutResponse {
    const queryClient = useQueryClient();

    const logOut = async () => {
        [
            [Queries.USER_INFO],
            [Queries.USER_KPIS],
            [Queries.USER_FIND_ALL],
            [Queries.TRANSACTION_KPIS],
            [Queries.PROGRAM_KPIS],
            [Queries.PARTNER_KPIS],
            [Queries.PARTNER_FIND_ALL],
            [Queries.PROGRAM_FIND_ALL],
            [Queries.POINT_FIND_BY],
            [Queries.ACCOUNT_NEAR_BALANCE],
            [Queries.POINTS_BALANCE],
            [Queries.TRANSACTION_FIND_ALL],
            [Queries.TRANSACTIONS_STATS],
            [Queries.PARTNER_BALANCE],
        ].forEach((queryKey) => queryClient.removeQueries({ queryKey }));

        await authService.logout();
    };

    return { logOut };
}
